// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"588c1fa0","480":"3f05668f"}[chunkId] + ".js";
};